// test998
(998 && 0);
